
Jasper = window.Jasper || {};

Jasper.Tables = {
    
    init: function(){
        if (!jQuery().dataTable) {
            return;
        }
        $('table.jasperDataTableResponsive').each(function() {
            var table = new Jasper.Tables.Responsive($(this));
        });
    },
    
    Responsive : function($table){
        if (!$.fn.dataTable.isDataTable($table)) {
            var oTable = $table.dataTable({
                responsive: true,
                buttons: false,
                paging:false,
                ordering:false,
                info: false,
                bFilter:false,
                bAutoWidth: false
            });
        }
    }    
};

$(document).ready(function(){
    Jasper.Tables.init();
    
    App.unblockUI('.page-content');
});


